import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getLatestFlow = {
  name: "getLatestFlow" as const,
  input: z.object({
    teamId: zExt.objectId(),
    flowType: z.string(),
    requirePublished: z.boolean(),
  }),
  output: z.object({ flow: z.any().nullable() }),
};
